import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import './css/Effects.css';
import './css/Fonts.css';
import './css/Listings.css';
import './css/Main.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
